module.exports = __webpack_public_path__ + "static/media/SmartShop_3-704w.56be2dae.png";